import React from "react"
import { WishlistAvailabilityItem } from "../../../api/backend/backend-api"
import { getWishlistAvailability } from "../../../api/backend/wishlist/api"
import { useLanguageId } from "../../localization/hooks"
import { useWishlist } from "./useWishlist"

export interface WishlistAvailability {
  items: WishlistAvailabilityItem[] | undefined
  loading: boolean
}

export const useWishlistAvailability = (): WishlistAvailability => {
  const { wishlist, initialized } = useWishlist()
  const languageId = useLanguageId()

  const [data, setData] = React.useState<WishlistAvailability>({
    items: undefined,
    loading: true,
  })

  const refreshWishlist = async () => {
    if (initialized && !wishlist) {
      setData({
        items: [],
        loading: false,
      })
      return
    }

    if (!wishlist) {
      return
    }
    const result = await getWishlistAvailability({
      input: {
        languageId,
        wishlistId: wishlist.id,
      },
    })
    setData({
      items: result.data.wishlistAvailability.items as
        | WishlistAvailabilityItem[]
        | undefined,
      loading: false,
    })
  }

  React.useEffect(() => {
    refreshWishlist()
  }, [wishlist?.items.length, initialized])

  return data
}
